import styled, { css } from 'styled-components';
import { getIconPath } from '../../../../../../../utils';

export const StyledFiltersWrapper = styled.div``;

export const StyledFilter = styled.button`
  padding: 12px;
  display: flex;
  font-size: 14px;
  font-weight: ${({ isDropdownOpen }) => (isDropdownOpen ? 800 : 500)};
  font-family: 'Nunito';
  border: none;
  background-color: ${({ theme, isDropdownOpen }) =>
    isDropdownOpen ? '#f3f3f3' : theme.colors.WHITE};
  cursor: pointer;
`;

export const StyledFilterDropdown = styled.div`
  position: absolute;
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
  background-color: ${(props) => props.theme.colors.WHITE};
  z-index: ${(props) => props.theme.zindex.zModal};
  overflow: hidden;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  box-shadow: 4px 4px 12px 0 rgba(0, 0, 0, 0.08);
  padding: 12px;
  transition: opacity 0.3s ease;
`;

export const StyledFilterItemsWrapper = styled.div`
  display: flex;
  gap: 12px;
  max-width: 650px;
  max-height: 344px;
  flex-wrap: wrap;
  margin-top: ${({ isFilterTabs }) => (isFilterTabs ? '20px' : '')};
  overflow-y: auto;
`;

export const StyledDropdownIcon = styled.div`
  background-image: url(${getIconPath('dropdown-icon')});
  width: 20px;
  height: 20px;
  ${({ isDropdownOpen }) =>
    isDropdownOpen
      ? css`
          transform: rotate(180deg);
        `
      : css`
          transform: rotate(0deg);
        `}
  transition: transform 0.5s ease;
`;

export const StyledDownArrow = styled.span`
  outline: none;
  position: relative;
  display: inline-block;
  padding-right: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
  cursor: pointer;
  transition: transform 0.5s ease;

  &:after {
    content: '';
    position: absolute;
    transform: rotate(45deg);
    width: 8px;
    height: 2px;
    background: ${(props) => props.theme.colorPalette.gray['1050']};
    top: 10px;
    right: 6px;
  }
  &:before {
    content: '';
    position: absolute;
    width: 8px;
    height: 2px;
    border-radius: 15px;
    background: ${(props) => props.theme.colorPalette.gray['1050']};
    top: 10px;
    right: 1px;
    bottom: 16px;
    transform: rotate(-45deg);
  }

  &.expanded {
    margin-bottom: 16px;
    &:after {
      transform: rotate(-45deg);
    }
    &:before {
      transform: rotate(45deg);
    }
  }
`;
